import { useEffect } from "react";
import useWebSocket from "react-use-websocket";
import { useImmer } from "use-immer";

import { WebsocketData } from "@intelligems/ig-types";

import { getAuthToken } from "../utils";

export const useWebsocket = (orgId?: string) => {
  const [url, setUrl] = useImmer<string | null>(null);

  const token = getAuthToken();

  useEffect(() => {
    if (orgId) {
      setUrl(`${import.meta.env.VITE_WEBSOCKET_URL}`);
    }
  }, [orgId]);

  // @ts-ignore
  return useWebSocket<WebsocketData>(orgId && token ? url : null, {
    share: true,
    onError: (err: WebSocketEventMap["error"]) => {
      console.log(err);
    },
    shouldReconnect: (closeEvent) => true,
    queryParams:
      orgId && token
        ? {
            orgId,
            token,
          }
        : undefined,
  });
};
